/**
 * Which signup experience a member went through.
 *
 * Both flows can be live at once (the single-page flow is behind the
 * `single-page-application` flag), and they **share** `/apply/review` and
 * `/apply/success` — so the conversion events fired from `SignupForm` come
 * from both. Without this property on every funnel event there is no way to
 * attribute a conversion to a flow, which is what an A/B comparison needs.
 *
 * Threaded down from the route, since that is the only place that knows which
 * experience the visitor was served.
 */
export const APPLICATION_FLOW = {
  MULTI_PAGE: 'multi_page',
  SINGLE_PAGE: 'single_page'
} as const;

export type ApplicationFlow =
  (typeof APPLICATION_FLOW)[keyof typeof APPLICATION_FLOW];

// Maps application_flow (multi_page/single_page) to the experiment's variant_name vocabulary (multi_step/one_page).
export const APPLICATION_FLOW_VARIANT: Record<ApplicationFlow, string> = {
  [APPLICATION_FLOW.MULTI_PAGE]: 'multi_step',
  [APPLICATION_FLOW.SINGLE_PAGE]: 'one_page'
};
